import useEnvironment from '~/composables/useEnvironment'

const { isProd } = useEnvironment()

export default function useContextMapper() {
  const testEnvMap = new Map<string, number>([
    ['FRA:aarstrinn8', 320201],
    ['FRA:aarstrinn9', 320202],
    ['FRA:aarstrinn10', 320203],
  ])

  const prodEnvMap = new Map<string, number>([
    ['FRA:aarstrinn8', 380244],
    ['FRA:aarstrinn9', 380246],
    ['FRA:aarstrinn10', 380247],
  ])

  const contextMap = isProd() ? prodEnvMap : testEnvMap

  const getContextsBySubjectAndGrade = (subjects: string[], grades: string[]): number[] => {
    const results: number[] = []
    const seen = new Set<number>()
    for (const subject of subjects) {
      for (const grade of grades) {
        const key = `${subject}:${grade}`
        const value = contextMap.get(key)
        if (value !== undefined && !seen.has(value)) {
          seen.add(value)
          results.push(value)
        }
      }
    }
    return results
  }

  return {
    getContextsBySubjectAndGrade
  }
}
